/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "attestPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "pa",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "product",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "priceType",
                type: "uint8",
            },
        ],
        name: "latestAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct PythStructs.UpgradeContract",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedPriceAttestation",
                type: "bytes",
            },
        ],
        name: "parsePriceAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "pa",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyPythVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "testNewImplementationActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "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";
var MockPythImplementation__factory = /** @class */ (function (_super) {
    __extends(MockPythImplementation__factory, _super);
    function MockPythImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockPythImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockPythImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockPythImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockPythImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockPythImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    MockPythImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    MockPythImplementation__factory.bytecode = _bytecode;
    MockPythImplementation__factory.abi = _abi;
    return MockPythImplementation__factory;
}(ContractFactory));
export { MockPythImplementation__factory };
